import {
  BaseEvent,
  EventType,
  isStoppageEventType,
  ShiftEventAndUpdateEvent,
  StoppageKind
} from '@domain/shifthandover'
import {MAX_DESCRIPTION_CHARACTER_LIMIT} from '@hconnect/common/consts'
import {removeMarkdownTags} from '@hconnect/common/utils'
import {
  shouldNotBeEmpty,
  shouldNotBeEmptyString,
  shouldNotBeEmptyStringWithMaxLength,
  ValidatorConfig
} from '@hconnect/common/validators'
import {TFunction} from 'i18next'

import {stoppageValidatorConfig} from '../components/eventForm/StoppageForm'
import {taskValidatorConfig} from '../components/eventForm/TaskForm'
import {
  commonFormScheduleEndValidator,
  maxStringLengthRequiredValidator,
  maxStringLengthValidator
} from '../validators'
import {approversValidator} from '../validators/shiftEvent.validators'

export const systemChangeRequestValidatorConfig: ValidatorConfig<ShiftEventAndUpdateEvent> =
  new Map([
    ['parameterChange.functionId', shouldNotBeEmpty<ShiftEventAndUpdateEvent>()],
    [
      'description',
      shouldNotBeEmptyStringWithMaxLength<ShiftEventAndUpdateEvent>(
        MAX_DESCRIPTION_CHARACTER_LIMIT,
        removeMarkdownTags
      )
    ],
    ['status', shouldNotBeEmpty<ShiftEventAndUpdateEvent>()],
    ['title', shouldNotBeEmptyString<ShiftEventAndUpdateEvent>()],
    ['schedule', commonFormScheduleEndValidator],
    ['approvers', approversValidator],
    ['parameterChange.currentValue', maxStringLengthValidator<ShiftEventAndUpdateEvent>()],
    ['parameterChange.newValue', maxStringLengthValidator<ShiftEventAndUpdateEvent>()]
  ])

export const parameterChangeValidatorConfig: ValidatorConfig<ShiftEventAndUpdateEvent> = new Map([
  ['category', shouldNotBeEmpty<ShiftEventAndUpdateEvent>()],
  [
    'description',
    shouldNotBeEmptyStringWithMaxLength<ShiftEventAndUpdateEvent>(
      MAX_DESCRIPTION_CHARACTER_LIMIT,
      removeMarkdownTags
    )
  ],
  ['status', shouldNotBeEmpty<ShiftEventAndUpdateEvent>()],
  ['title', shouldNotBeEmptyString<ShiftEventAndUpdateEvent>()],
  ['schedule', commonFormScheduleEndValidator],
  ['approvers', approversValidator],
  ['parameterChange.currentValue', maxStringLengthRequiredValidator<ShiftEventAndUpdateEvent>()],
  ['parameterChange.newValue', maxStringLengthRequiredValidator<ShiftEventAndUpdateEvent>()]
])

const spotEventValidatorConfig: ValidatorConfig<ShiftEventAndUpdateEvent> = new Map([
  [
    'description',
    shouldNotBeEmptyStringWithMaxLength<ShiftEventAndUpdateEvent>(
      MAX_DESCRIPTION_CHARACTER_LIMIT,
      removeMarkdownTags
    )
  ],
  ['title', shouldNotBeEmptyString<ShiftEventAndUpdateEvent>()],
  ['schedule', commonFormScheduleEndValidator]
])

const eventValidatorConfig: ValidatorConfig<ShiftEventAndUpdateEvent> = new Map([
  ['category', shouldNotBeEmpty<ShiftEventAndUpdateEvent>()],
  [
    'description',
    shouldNotBeEmptyStringWithMaxLength<ShiftEventAndUpdateEvent>(
      MAX_DESCRIPTION_CHARACTER_LIMIT,
      removeMarkdownTags
    )
  ],
  ['status', shouldNotBeEmpty<ShiftEventAndUpdateEvent>()],
  ['title', shouldNotBeEmptyString<ShiftEventAndUpdateEvent>()],
  ['schedule', commonFormScheduleEndValidator]
])

export const getTypeSpecificValidatorConfig = (
  t: TFunction,
  type?: EventType,
  isFunctionalLocationRequired?: boolean,
  existingEvent?: BaseEvent,
  skipOverlapValidation?: boolean
) => {
  if (!type) return eventValidatorConfig
  if (type === 'task') return taskValidatorConfig
  if (isStoppageEventType(type))
    return stoppageValidatorConfig(
      t,
      isFunctionalLocationRequired && type !== StoppageKind.PlannedStoppage,
      existingEvent,
      skipOverlapValidation
    )
  if (type === 'parameterChange') return parameterChangeValidatorConfig
  if (type === 'systemChangeRequest') return systemChangeRequestValidatorConfig
  if (type === 'spot') return spotEventValidatorConfig
  return eventValidatorConfig
}
